const state = {
  visao_vertical: localStorage.config_orientacao_vertical_tela_compras !== 'N',
  produto_selecionado: {},
  filtros: {
    grupos: [],
    filiais: [],
    segmentos: [],
    secoes: [],
    categorias: [],
    linhas: [],
    compradores: [],
    fornecedores: [],
    marcas: [],
    status_compra: [],
    status_produto: [],
    histogramas: [],
    status_ativo_fora_linha: [],
    status: [],
    aplicacao: [],
    pesquisa: '',
    compra_produtos_combinados_ativa: false,
    compra_categorias_ativa: false,
    exibir_produtos_inativos: false,
  },
  callbackRecarregarTabelaProdutos: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackRecarregarPedidosCompraCarrinho: () => {
    throw new Error('função ainda não referenciada!');
  },
  callbackRecarregarQtdeProdutosSilenciados: () => {
    throw new Error('função ainda não referenciada!');
  },
}

const getters = {
  getAplicacao(state) {
    return state.filtros.aplicacao;
  },
  getVisaoVertical(state) {
    return state.visao_vertical;
  },
  getFiltros(state){
    return state.filtros;
  },
  getFiltrosGerais(state){
    return {
      grupos: state.filtros.grupos,
      filiais: state.filtros.filiais,
      segmentos: state.filtros.segmentos,
      categorias: state.filtros.categorias,
      linhas: state.filtros.linhas,
      secoes: state.filtros.secoes,
      compradores: state.filtros.compradores,
      fornecedores: state.filtros.fornecedores,
      marcas: state.filtros.marcas
    };
  },
  getProdutoSelecionado(state){
    return state.produto_selecionado;
  },
  getPesquisa(state){
    return state.filtros.pesquisa;
  },
  getExibirProdutosInativos(state){
    return state.filtros.exibir_produtos_inativos;
  },
  getHistogramas(state){
    return state.filtros.histogramas;
  },
  getStatus(state){
    return state.filtros.status;
  },
  callbackRecarregarTabelaProdutos(state) {
    return state.callbackRecarregarTabelaProdutos;
  },
  callbackRecarregarPedidosCompraCarrinho(state) {
    return state.callbackRecarregarPedidosCompraCarrinho;
  },
  callbackRecarregarQtdeProdutosSilenciados(state) {
    return state.callbackRecarregarQtdeProdutosSilenciados;
  },
}

const mutations = {
  setAplicacao(state, valor) {
    state.filtros.aplicacao = valor;
  },
  setFiltros(state, valor) {
    state.filtros = valor;
  },
  setVisaoVertical(state, valor) {
    return state.visao_vertical = valor;
  },
  setProdutoSelecionado(state, valor) {
    return state.produto_selecionado = valor;
  },
  setPesquisa(state, valor) {
    return state.filtros.pesquisa = valor;
  },
  getExibirProdutosInativos(state, valor) {
    return state.filtros.exibir_produtos_inativos = valor;
  },
  setHistogramas(state, valor){
    state.filtros.histogramas = valor;
  },
  setStatus(state, valor){
    state.filtros.status = valor;
  },
  callbackRecarregarTabelaProdutos(state, valor){
    state.callbackRecarregarTabelaProdutos = valor
  },
  callbackRecarregarPedidosCompraCarrinho(state, valor){
    state.callbackRecarregarPedidosCompraCarrinho = valor
  },
  callbackRecarregarQtdeProdutosSilenciados(state, valor){
    state.callbackRecarregarQtdeProdutosSilenciados = valor
  },
}

const actions = {
  setFiltros: ({ commit }, valor) => {
    commit("setFiltros", valor)
  },
  setVisaoVertical: ({ commit }, valor) => {
    commit("setVisaoVertical", valor)
  },
  setProdutoSelecionado: ({ commit }, valor) => {
    commit("setProdutoSelecionado", valor)
  },
  setPesquisa({ commit }, valor) {
    commit("setPesquisa", valor)
  },
  getExibirProdutosInativos({ commit }, valor) {
    commit("getExibirProdutosInativos", valor)
  },
  setHistogramas({ commit }, valor){
    commit("setHistogramas", valor);
  },
  setStatus({ commit }, valor){
    commit("setStatus", valor);
  },
  setAplicacao({ commit }, valor){
    commit("setAplicacao", valor);
  },
  callbackRecarregarTabelaProdutos(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o grid de produtos!`);
    }

    context.commit("callbackRecarregarTabelaProdutos", payload);
  },
  callbackRecarregarPedidosCompraCarrinho(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o grid de produtos!`);
    }

    context.commit("callbackRecarregarPedidosCompraCarrinho", payload);
  },
  callbackRecarregarQtdeProdutosSilenciados(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza a quantidade de produtos silenciados!`);
    }

    context.commit("callbackRecarregarQtdeProdutosSilenciados", payload);
  },
}

export default { namespaced: true, state, mutations, getters, actions }
